export const LANGUAGES_LIST = [
  'Albanian',
  'Arabic',
  'Bengali',
  'Bosnian',
  'Bulgarian',
  'Chinese',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Estonian',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hindi',
  'Hungarian',
  'Icelandic',
  'Indonesian',
  'Irish',
  'Italian',
  'Japanese',
  'Latvian',
  'Lithuanian',
  'Luxembourgish',
  'Macedonian',
  'Marathi',
  'Maltese',
  'Montenegrin',
  'Norwegian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Serbian',
  'Slovak',
  'Slovenian',
  'Spanish',
  'Swahili',
  'Swedish',
  'Tamil',
  'Telugu',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
  'Welsh'
];
